const getLocationName = (invitation, location) => {
  return invitation.meetingType && invitation.meetingType.type === 'VENUE' && location ? location.name : null
}

export default getLocationName
